// extracted by mini-css-extract-plugin
export default {"wrapper":"d5-z","play":"e5-z"};